// src/components/RecipeModal.jsx
import React from 'react';
import { ChefHat, Clock, Star, Trophy, Utensils, Sparkles, X, Zap } from 'lucide-react';
import './RecipeModal.css';

const getCuisineFlag = (cuisine) => {
  const flags = {
    Indonesian: '🇮🇩',
    Japanese: '🇯🇵',
    Korean: '🇰🇷',
    Italian: '🇮🇹',
    Mexican: '🇲🇽',
    Chinese: '🇨🇳',
    Thai: '🇹🇭',
    Indian: '🇮🇳',
    Western: '🍔',
    Fusion: '✨'
  };
  return flags[cuisine] || '🍽️';
};

const RecipeModal = ({ recipe, onClose, onCook }) => {
  if (!recipe) return null;

  return (
    <div 
      className="recipe-modal-overlay" 
      onClick={onClose}
    >
      <div 
        className="recipe-modal-content" 
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="modal-header-section">
          <div>
            <h2 className="modal-recipe-title">
              <span className="modal-flag">{getCuisineFlag(recipe.cuisine)}</span>
              {recipe.name.toUpperCase()}
              {recipe.special && <span className="modal-special-star">★</span>}
            </h2>
            <p className="modal-cuisine-text">{recipe.cuisine} Cuisine</p>
          </div>
          <button 
            onClick={onClose} 
            className="modal-close-btn"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Recipe Info */}
        <div className="modal-info-grid">
          <div className="modal-info-box modal-time-box">
            <Clock className="modal-icon" />
            <p className="modal-info-text">{recipe.time}</p>
          </div>
          <div className={`modal-info-box modal-difficulty-box difficulty-${recipe.difficulty.toLowerCase()}`}>
            <Star className="modal-icon" />
            <p className="modal-info-text">
              {recipe.difficulty}
            </p>
          </div>
          <div className="modal-info-box modal-points-box">
            <Trophy className="modal-icon" />
            <p className="modal-info-text">+{recipe.points} PTS</p>
          </div>
        </div>

        {/* Ingredients */}
        <div className="modal-section">
          <h3 className="modal-section-heading modal-ingredients-heading">
            <Utensils className="modal-heading-icon" /> INGREDIENTS
          </h3>
          <div className="modal-list-box modal-ingredients-box">
            <ul className="modal-list">
              {recipe.ingredients.map((ing, i) => (
                <li key={i} className="modal-list-item">
                  <span className="modal-bullet">•</span>
                  <span className="capitalize">{ing}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Sauces & Seasonings */}
        <div className="modal-section">
          <h3 className="modal-section-heading modal-sauces-heading">
            <Sparkles className="modal-heading-icon" /> SAUCES & SEASONINGS
          </h3>
          <div className="modal-list-box modal-sauces-box">
            <ul className="modal-list">
              {recipe.sauces.map((sauce, i) => (
                <li key={i} className="modal-list-item">
                  <span className="modal-bullet">•</span>
                  <span className="capitalize">{sauce}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Instructions */}
        <div className="modal-section">
          <h3 className="modal-section-heading modal-instructions-heading">
            <ChefHat className="modal-heading-icon" /> COOKING INSTRUCTIONS
          </h3>
          <div className="modal-instructions-box">
            <ol className="modal-instructions-list">
              {recipe.instructions.split('. ').filter(step => step.trim()).map((step, i) => (
                <li key={i} className="modal-instruction-step">
                  <span className="modal-step-number">{i + 1}.</span>
                  <span>{step.trim()}{step.endsWith('.') ? '' : '.'}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="modal-actions">
          {onCook && (
            <button 
              onClick={() => {
                onCook(recipe);
                onClose();
              }}
              className="modal-action-btn modal-cook-btn"
            >
              <Zap className="modal-btn-icon" /> COOK THIS! (+{recipe.points} PTS)
            </button>
          )}
          <button 
            onClick={onClose}
            className="modal-action-btn modal-close-action-btn"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecipeModal;
